/** Hover text for disabled read-only connector source tiles. */
export const READ_ONLY_CONNECTOR_TOOLTIP =
  'This connector is not enabled. Contact your administrator for access.';

export const sourceTypeList = {
  INBOUND: [
    {
      dataSource: 'S3',
      id: 'S3',
      type: 'S3',
      title: 'Amazon S3',
    },
    {
      dataSource: 'REDSHIFT',
      id: 'REDSHIFT',
      type: 'REDSHIFT',
      title: 'REDSHIFT',
    },
    {
      dataSource: 'GCS',
      id: 'GCS',
      type: 'GCS',
      title: 'Google GCS',
    },
    {
      dataSource: 'SNOWFLAKE',
      id: 'SNOWFLAKE',
      type: 'SNOWFLAKE',
      title: 'Snowflake',
    },
    {
      dataSource: 'GA',
      id: 'GA',
      type: 'GA',
      title: 'Google Analytics',
    },
    {
      dataSource: 'BIGQUERY',
      id: 'BIGQUERY',
      type: 'BIGQUERY',
      title: 'BigQuery',
    },
    {
      dataSource: 'SALESFORCE',
      id: 'SALESFORCE',
      type: 'SALESFORCE',
      title: 'Salesforce',
    },
    {
      dataSource: 'LIVERAMP',
      id: 'LIVERAMP',
      type: 'LIVERAMP',
      title: 'LiveRamp',
    },
    {
      dataSource: 'THETRADEDESK',
      id: 'THETRADEDESK',
      type: 'THETRADEDESK',
      title: 'The Trade Desk',
    },
    {
      dataSource: 'POSTHOG',
      id: 'POSTHOG',
      type: 'POSTHOG',
      title: 'PostHog',
    },
    {
      dataSource: 'AZURE_BLOB',
      id: 'AZURE_BLOB',
      type: 'AZURE_BLOB',
      title: 'Azure Blob Storage',
    },
    {
      dataSource: 'MFU',
      id: 'MFU',
      type: 'MFU',
      title: 'Direct File Upload',
    },
    {
      dataSource: 'MFT',
      id: 'MFT',
      type: 'MFT',
      title: 'MFT (Managed File Transfer)',
    },
    {
      dataSource: 'SQL_SERVER',
      id: 'SQL_SERVER',
      type: 'SQL_SERVER',
      title: 'MS SQL Server',
      imageSrc: '/sql-server.png',
    },
  ],
  OUTBOUND: [
    {
      dataSource: 'S3',
      id: 'S3',
      type: 'S3',
      title: 'Amazon S3',
    },
    {
      dataSource: 'GCS',
      id: 'GCS',
      type: 'GCS',
      title: 'Google GCS',
    },
    {
      dataSource: 'AZURE_BLOB',
      id: 'AZURE_BLOB',
      type: 'AZURE_BLOB',
      title: 'Azure Blob Storage',
    },
  ],
};

export const connectorHeaders = [
  {
    header: 'Desc',
    key: 'desc',
  },
];

export const connectorRows = {
  INBOUND: [
    {
      id: 'S3',
      desc: 'S3 Connector Details',
    },
    {
      id: 'REDSHIFT',
      desc: 'Redshift Connector Details',
    },
    {
      id: 'GCS',
      desc: 'GCS Connector Details',
    },
    {
      id: 'POSTHOG',
      desc: 'PostHog Connector Details',
    },
    {
      id: 'SALESFORCE',
      desc: 'Salesforce Connector Details',
    },
    {
      id: 'GA',
      desc: 'Google Analytics Connector Details',
    },
    {
      id: 'BIGQUERY',
      desc: 'BigQuery Connector Details',
    },
    {
      id: 'AZURE_BLOB',
      desc: 'Azure Blob Storage Connector Details',
    },
    {
      id: 'MFU',
      desc: 'Direct File Upload Connector',
    },
    {
      id: 'MFT',
      desc: 'MFT Connector (mailbox + notification list)',
    },
  ],
  OUTBOUND: [
    {
      id: 'S3',
      desc: 'S3 Connector Details',
    },
    {
      id: 'GCS',
      desc: 'GCS Connector Details',
    },
    {
      id: 'AZURE_BLOB',
      desc: 'Azure Blob Storage Connector Details',
    },
  ],
};

export const classifiedConnectorHeaders = {
  S3: [
    {
      header: 'Connector Name',
      key: 'connector_title',
    },
    {
      header: 'Bucket Name',
      key: 'connector_name',
    },
    {
      header: 'Region',
      key: 'cloud_region',
    },
    {
      header: 'Created at',
      key: 'create_time',
    },
    {
      header: 'Created by',
      key: 'create_user',
    },
  ],
  REDSHIFT: [
    {
      header: 'Connector Name',
      key: 'connector_title',
    },
    {
      header: 'Datashare Name',
      key: 'connector_name',
    },
    {
      header: 'Created at',
      key: 'create_time',
    },
    {
      header: 'Created by',
      key: 'create_user',
    },
  ],
  GCS: [
    {
      header: 'Connector Name',
      key: 'connector_title',
    },
    {
      header: 'Bucket Name',
      key: 'connector_name',
    },
    {
      header: 'Region',
      key: 'cloud_region',
    },
    {
      header: 'Created at',
      key: 'create_time',
    },
    {
      header: 'Created by',
      key: 'create_user',
    },
  ],
  POSTHOG: [
    {
      header: 'Connector Name',
      key: 'connector_title',
    },
    {
      header: 'Project ID',
      key: 'connector_name',
    },
    {
      header: 'Created at',
      key: 'create_time',
    },
    {
      header: 'Created by',
      key: 'create_user',
    },
  ],
  SALESFORCE: [
    {
      header: 'Connector Name',
      key: 'connector_title',
    },
    {
      header: 'Client ID',
      key: 'connector_name',
    },
    {
      header: 'Created at',
      key: 'create_time',
    },
    {
      header: 'Created by',
      key: 'create_user',
    },
  ],
  GA: [
    {
      header: 'Connector Name',
      key: 'connector_title',
    },
    {
      header: 'Property ID',
      key: 'connector_name',
    },
    {
      header: 'Created at',
      key: 'create_time',
    },
    {
      header: 'Created by',
      key: 'create_user',
    },
  ],
  BIGQUERY: [
    {
      header: 'Connector Name',
      key: 'connector_title',
    },
    {
      header: 'Dataset ID',
      key: 'connector_name',
    },
    {
      header: 'Created at',
      key: 'create_time',
    },
    {
      header: 'Created by',
      key: 'create_user',
    },
  ],
  AZURE_BLOB: [
    {
      header: 'Connector Name',
      key: 'connector_title',
    },
    {
      header: 'Storage Account',
      key: 'storage_account',
    },
    {
      header: 'Container',
      key: 'container',
    },
    {
      header: 'Created at',
      key: 'create_time',
    },
    {
      header: 'Created by',
      key: 'create_user',
    },
  ],
  MFU: [
    {
      header: 'Connector Name',
      key: 'connector_title',
    },
    {
      header: 'Connector ID',
      key: 'connector_name',
    },
    {
      header: 'Created at',
      key: 'create_time',
    },
    {
      header: 'Created by',
      key: 'create_user',
    },
  ],
  MFT: [
    {
      header: 'Connector Name',
      key: 'connector_title',
    },
    {
      header: 'Mailbox Name',
      key: 'connector_name',
    },
    {
      header: 'Created at',
      key: 'create_time',
    },
    {
      header: 'Created by',
      key: 'create_user',
    },
  ],
};

export const supportedRegions = {
  S3: {
    'US East (Ohio)': 'us-east-2',
    'US East (N.Virginia)': 'us-east-1',
    'US West (N. California)': 'us-west-1',
    'US West (Oregon)': 'us-west-2',
  },
  GCS: {
    'Multi Region': 'US',
    'US Central (Iowa)': 'us-central1',
    'US East (South Carolina)': 'us-east1',
    'US East (Northern Virginia)': 'us-east4',
    'US East (Columbus)': 'us-east5',
    'US South (Dallas)': 'us-south1',
    'US West (Oregon)': 'us-west1',
    'US West (Los Angeles)': 'us-west2',
    'US West (Salt Lake City)': 'us-west3',
    'US West (Las Vegas)': 'us-west4',
  },
};
